import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./shared/layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
        title: 'Home',
      },
      {
        path: 'shop',
        loadComponent: () => import('./features/shop/shop.component').then((m) => m.ShopComponent),
        title: 'Shop',
      },
      {
        path: 'products/:handle',
        loadComponent: () =>
          import('./features/product-details/product-details.component').then(
            (m) => m.ProductDetailsComponent,
          ),
        title: 'Product',
      },
      {
        path: 'collections',
        loadComponent: () =>
          import('./features/collections/collections.component').then((m) => m.CollectionsComponent),
        title: 'Collections',
      },
      {
        path: 'collections/:handle',
        loadComponent: () =>
          import('./features/collections/collection-detail.component').then(
            (m) => m.CollectionDetailComponent,
          ),
        title: 'Collection',
      },
      {
        path: 'cart',
        loadComponent: () => import('./features/cart/cart.component').then((m) => m.CartComponent),
        title: 'Cart',
      },
      {
        path: 'wishlist',
        loadComponent: () =>
          import('./features/wishlist/wishlist.component').then((m) => m.WishlistComponent),
        title: 'Wishlist',
      },
      {
        path: 'checkout',
        loadComponent: () =>
          import('./features/checkout/checkout.component').then((m) => m.CheckoutComponent),
        title: 'Checkout',
      },
      // Auth routes (guest only)
      {
        path: 'login',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/login/login.component').then((m) => m.LoginComponent),
        title: 'Sign In',
      },
      {
        path: 'register',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/register/register.component').then((m) => m.RegisterComponent),
        title: 'Create Account',
      },
      {
        path: 'forgot-password',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/forgot-password/forgot-password.component').then(
            (m) => m.ForgotPasswordComponent,
          ),
        title: 'Forgot Password',
      },
      {
        path: 'reset-password',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
        title: 'Reset Password',
      },
      {
        path: 'reset-password/:id/:token',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
        title: 'Reset Password',
      },
      // Shopify-style recovery path (guest) — must stay outside auth-guarded /account
      {
        path: 'account/reset/:id/:token',
        canActivate: [guestGuard],
        loadComponent: () =>
          import('./features/auth/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent,
          ),
        title: 'Reset Password',
      },
      // Account routes (authenticated)
      {
        path: 'account',
        canActivate: [authGuard],
        loadComponent: () =>
          import('./features/account/account-layout.component').then((m) => m.AccountLayoutComponent),
        children: [
          { path: '', redirectTo: 'profile', pathMatch: 'full' },
          {
            path: 'profile',
            loadComponent: () =>
              import('./features/account/profile/account-profile.component').then(
                (m) => m.AccountProfileComponent,
              ),
            title: 'Profile',
          },
          {
            path: 'wishlist',
            loadComponent: () =>
              import('./features/account/wishlist/account-wishlist.component').then(
                (m) => m.AccountWishlistComponent,
              ),
            title: 'Wishlist',
          },
          {
            path: 'orders',
            loadComponent: () =>
              import('./features/account/orders/account-orders.component').then(
                (m) => m.AccountOrdersComponent,
              ),
            title: 'Orders',
          },
          {
            path: 'orders/:id',
            loadComponent: () =>
              import('./features/account/orders/account-order-detail.component').then(
                (m) => m.AccountOrderDetailComponent,
              ),
            title: 'Order Detail',
          },
          {
            path: 'addresses',
            loadComponent: () =>
              import('./features/account/addresses/account-addresses.component').then(
                (m) => m.AccountAddressesComponent,
              ),
            title: 'Addresses',
          },
        ],
      },
      // Legacy redirects
      { path: 'profile', redirectTo: 'account/profile', pathMatch: 'full' },
      { path: 'orders', redirectTo: 'account/orders', pathMatch: 'full' },
      {
        path: 'blog',
        loadComponent: () => import('./features/blog/blog.component').then((m) => m.BlogComponent),
        title: 'The Journal',
      },
      {
        path: 'blog/:blogHandle/:articleHandle',
        loadComponent: () =>
          import('./features/blog/blog-article.component').then((m) => m.BlogArticleComponent),
        title: 'Article',
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./features/contact/contact.component').then((m) => m.ContactComponent),
        title: 'Contact',
      },
      {
        path: 'about',
        loadComponent: () => import('./features/about/about.component').then((m) => m.AboutComponent),
        title: 'Our Story',
      },
      {
        path: 'sound-healing',
        loadComponent: () =>
          import('./features/sound-healing/sound-healing.component').then(
            (m) => m.SoundHealingComponent,
          ),
        title: 'Sound Healing',
      },
      // Legacy redirect
      { path: 'healing-sessions', redirectTo: 'sound-healing', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
